import { AxiosError } from 'axios';
import { POST_ADMIN_APPLICATION_FILE_PRESIGNED_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PresignedUrlRequest {
  applicationType: string;
  filenames: string[];
  uuid?: string;
}

export interface PresignedUrlResponseObject {
  key: string;
  presignedUrl: string;
}
// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PresignedUrlResponseObject[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAdminApplicationFilePresigned = ({ onSuccess, onError }: Input = {}) => {
  const postAdminApplicationFilePresigned = async (requestData: PresignedUrlRequest) => {
    const res = await axiosClient.post<PresignedUrlResponseObject[]>(
      POST_ADMIN_APPLICATION_FILE_PRESIGNED_URL,
      requestData
    );
    return res.data;
  };

  return useCustomMutation(postAdminApplicationFilePresigned, {
    onSuccess,
    onError,
  });
};
